import { GenIcon } from '../helpers/IconBase.es.js';

const StoreBuyerColored = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 20 20", fill: "none" },
    child: [
      {
        tag: "g",
        attr: { clipPath: "url(#clip0_1338_7010)" },
        child: [
          {
            tag: "path",
            attr: {
              d: "M3.33333 12.4999H4.16667C5.16667 12.4999 6.055 12.0482 6.66667 11.3482C7.27833 12.0482 8.16667 12.4999 9.16667 12.4999H10.8333C11.215 12.4999 11.5892 12.4357 11.945 12.309C12.3792 12.1549 12.6058 11.679 12.4517 11.2449C12.2967 10.8107 11.82 10.5857 11.3883 10.7382C11.2117 10.8007 11.0242 10.8324 10.8333 10.8324H9.16667C8.2475 10.8324 7.5 10.0849 7.5 9.16569C7.5 8.70569 7.12667 8.33236 6.66667 8.33236C6.20667 8.33236 5.83333 8.70569 5.83333 9.16569C5.83333 10.0849 5.08583 10.8324 4.16667 10.8324H3.33333C2.435 10.8324 1.70083 10.1182 1.6675 9.22736L2.6225 3.43652C2.94167 2.39236 3.91833 1.66569 5.01417 1.66569H5.83333V4.16569C5.83333 4.62569 6.20667 4.99902 6.66667 4.99902C7.12667 4.99902 7.5 4.62569 7.5 4.16569V1.66569H12.5V4.16569C12.5 4.62569 12.8725 4.99902 13.3333 4.99902C13.7942 4.99902 14.1667 4.62569 14.1667 4.16569V1.66569H14.985C16.08 1.66569 17.0575 2.39152 17.3767 3.43652L18.3317 9.22736C18.325 9.39652 18.2933 9.56236 18.2375 9.72152C18.0842 10.1557 18.3125 10.6315 18.7458 10.7849C19.1808 10.939 19.6558 10.7107 19.8092 10.2765C19.9342 9.91986 19.9992 9.54569 19.9992 9.16569C19.9992 9.11986 19 3.05152 18.9908 3.02069C18.4825 1.24152 16.8342 -0.000976562 14.9842 -0.000976562H5.01417C3.16417 -0.000143229 1.51667 1.24236 1.0075 3.02152C0.998333 3.05236 0 9.12069 0 9.16652C0 10.004 0.320833 10.7615 0.833333 11.3482V16.6665C0.833333 18.5049 2.32833 19.9999 4.16667 19.9999H9.16667C9.62667 19.9999 10 19.6265 10 19.1665C10 18.7065 9.62667 18.3332 9.16667 18.3332H4.16667C3.2475 18.3332 2.5 17.5857 2.5 16.6665V12.3815C2.76833 12.4515 3.04417 12.4999 3.33333 12.4999Z",
              fill: "#0200BC"
            }
          },
          {
            tag: "path",
            attr: {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M13.5172 11.5467C14.2027 11.0815 15.0089 10.8333 15.8337 10.8334C16.6577 10.8333 17.4633 11.0811 18.1485 11.5456C18.8337 12.0101 19.3678 12.6704 19.6832 13.4428C19.9985 14.2153 20.081 15.0654 19.9202 15.8854C19.7595 16.7055 19.3626 17.4588 18.7798 18.05L17.5071 19.3125C17.0583 19.7535 16.4581 20 15.8333 20C15.2086 20 14.6083 19.7535 14.1596 19.3125L12.893 18.0556C12.3087 17.465 11.9103 16.7118 11.7482 15.8913C11.5862 15.0708 11.6677 14.2199 11.9827 13.4465C12.2976 12.6731 12.8316 12.0119 13.5172 11.5467ZM17.8029 17.0481L16.5357 18.3057C16.3473 18.4908 16.0955 18.5942 15.8333 18.5942C15.5712 18.5942 15.3193 18.4908 15.131 18.3057L13.8693 17.0537C13.4811 16.6599 13.2167 16.1581 13.1094 15.6118C13.0022 15.0655 13.0568 14.4992 13.2666 13.9844C13.4763 13.4696 13.8317 13.0295 14.2878 12.7195C14.744 12.4095 15.2804 12.2437 15.8294 12.2429C16.3784 12.2421 16.9153 12.4064 17.3723 12.7151C17.8293 13.0237 18.1859 13.4629 18.3971 13.9771C18.6082 14.4912 18.6645 15.0574 18.5587 15.604C18.453 16.1506 18.19 16.6531 17.8029 17.0481Z",
              fill: "#00973C"
            }
          },
          {
            tag: "path",
            attr: {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M16.411 15.4478C16.4873 15.3319 16.528 15.1957 16.528 15.0564C16.528 14.8695 16.4549 14.6903 16.3247 14.5582C16.1944 14.4261 16.0178 14.3518 15.8337 14.3518C15.6963 14.3518 15.5621 14.3932 15.4479 14.4706C15.3337 14.548 15.2447 14.658 15.1922 14.7868C15.1396 14.9155 15.1259 15.0572 15.1526 15.1938C15.1794 15.3305 15.2456 15.456 15.3427 15.5546C15.4398 15.6531 15.5635 15.7202 15.6982 15.7474C15.8329 15.7746 15.9725 15.7606 16.0994 15.7073C16.2263 15.654 16.3347 15.5637 16.411 15.4478Z",
              fill: "#00973C"
            }
          }
        ]
      },
      {
        tag: "defs",
        attr: {},
        child: [
          {
            tag: "clipPath",
            attr: { id: "clip0_1338_7010" },
            child: [
              {
                tag: "rect",
                attr: { width: "20", height: "20", fill: "white" }
              }
            ]
          }
        ]
      }
    ]
  })(props);
};

export { StoreBuyerColored };
